import { Injectable, signal } from '@angular/core';
import { UserInteractionSnapshot } from './user-interaction.service';

export interface ServerErrorDialogState {
    visible: boolean;
    message: string;
    statusCode?: number;
    url?: string;
    method?: string;
    timestamp?: string;
    exceptionType?: string;
    stackTrace?: string;
    lastInteraction?: UserInteractionSnapshot | null;
    requestHeaders?: Record<string, string>;
}

const defaultState: ServerErrorDialogState = {
    visible: false,
    message: ''
};

@Injectable({ providedIn: 'root' })
export class ServerErrorDialogService {
    private readonly stateSignal = signal<ServerErrorDialogState>(defaultState);

    readonly state = this.stateSignal.asReadonly();

    show(state: Omit<ServerErrorDialogState, 'visible'>): void {
        this.stateSignal.set({
            visible: true,
            ...state
        });
    }

    hide(): void {
        this.stateSignal.set(defaultState);
    }
}
